
import React, { Fragment, useState } from 'react';
import { Redirect } from "react-router-dom";
import ProvaService from '../../services/prova';
import { Help } from "rbx";
import jwt from 'jwt-decode';

function LoginLink(props) {
    const [redirectToInicioProva, setRedirectToInicioProva] = useState(false);
    const [error, setError] = useState(false);
    const [response, setResponse] = useState('Dados Inválidos.');

    const handleSubmit = async () => {
        try {

            const parametro = props.match.params.id;
            const data = await await ProvaService.loginhash({ hashVestibular: parametro });

            if (data.type) {
                setResponse(data.message.error);
                setError(true)
            }else {

                setTimeout(() => {
                    handleInicio();
                }, 300);
            }
        } catch (error) {
            setError(true)
        }
    }
    const handleInicio = async (evt) => {
        let teste = localStorage.getItem('token');
        let dados = jwt(teste);
        const id_inscricao = dados.ID_Inscricao;

        try {
            const inicio = await ProvaService.inicio(id_inscricao);
            localStorage.setItem('dadosInicio', JSON.stringify(inicio.data))
            setTimeout(() => {
                setRedirectToInicioProva(true);
            }, 200);
        } catch (error) {
            setError(true)
        }
    }
    handleSubmit();

    if (redirectToInicioProva)
        return <Redirect to={{ pathname: "/vestibular/iniciar" }} />

    return (
        <Fragment>
            {error && <Help color="danger">{response} {error}  </Help>}
        </Fragment>
    )
}
export default LoginLink;